import React from "react";
import LoginAuth from '../components/auth/Login';

function Login(props) {
  return (
    <LoginAuth  />
  );
}
export default Login;
